<script>
export default {
  name: 'ButtonWebCall',
  props: {
    componentData: {
      type: Object,
      required: true,
    },
  },
}
</script>

<template>
  <div/>
</template>

<style scoped lang="scss" module>
</style>
